export default "LICENSE TBA\n"